var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isMounted && _vm.giftShow ? _c('Modal', {
    staticClass: "mod_actpop",
    on: {
      "close": _vm.closeGiftModal
    }
  }, [_c('div', {
    directives: [{
      name: "report",
      rawName: "v-report",
      value: _vm.reportData.礼包弹窗,
      expression: "reportData.礼包弹窗"
    }],
    staticClass: "img_area",
    on: {
      "click": _vm.clickGift
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.gift.tPicList.sPicUrl
    }
  })]), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.closeGiftModal
    }
  })]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };